import pickBy from 'lodash/pickBy.js'
import urljoin from 'url-join'
import pkg from '../../package.json'

import { useRuntimeConfig } from '#app'
import { defineNuxtPlugin } from '#imports'
import { useAuthToken } from '~/composables/auth/useAuthToken.js'

// let _apiUrl = null
// function setApiUrl(url) {
//   _apiUrl = url
// }

export default defineNuxtPlugin((nuxtApp) => {
  const { apiUrl, clientId, intranet } = useRuntimeConfig().public
  const { getAuthHeaders, token } = useAuthToken()

  let _errorHandler = null
  function setErrorHandler(handler) {
    _errorHandler = handler
  }

  function isValid(value) {
    return value !== undefined && value !== null
  }

  function _checkToken(req) {
    if (!req.isPublic && !req.token) {
      throw { code: 'ERR_A103', url: req.endpoint }
    }
  }

  const request = async (options) => {
    try {
      const { url, method, params, isPublic, headers, isFormData = false } = options
      const baseUrl = import.meta.server && intranet === '1' ? 'http://frontend-api-v2.default.svc.cluster.local' : nuxtApp.$fastApiUrl || apiUrl
      const endpoint = urljoin(baseUrl, url.replace(':clientId', clientId))
      _checkToken({ isPublic, endpoint, token: token.value })
      const isGet = method.toLowerCase() === 'get'
      const payloadKey = isGet ? 'query' : 'body'
      const payload = isFormData ? params : pickBy(params, isValid)

      // 不重試的錯誤碼列表
      const NO_RETRY_ERROR_CODES = [
        'ERR_F108', // 維護模式
        'ERR_A103', // Token 無效
        'ERR_G111', // Account Locking
        'ERR_A224', // Login Error
      ]

      const res = await $fetch(endpoint, {
        method,
        headers: {
          'X-TH1GAMES-VERSION': `v${pkg.version}`,
          'X-TH1GAMES-PLATFORM': 'pwa',
          ...getAuthHeaders(),
          ...headers,
        },
        [payloadKey]: payload,
        // ofetch retry 配置
        // retry: ({ response }) => {
        //   const errorCode = response?._data?.error?.code || response?.data?.error?.code
        //   // 不 Retry
        //   if (errorCode && NO_RETRY_ERROR_CODES.includes(errorCode)) {
        //     return 0
        //   }

        //   // 最多 Retry 2 次
        //   return 2
        // },
        retry: 2,
        retryDelay: 1000, // 重試延遲 1 秒（ofetch 會自動使用指數退避）
        retryStatusCodes: [408, 409, 425, 429, 500, 502, 504], // 需要重試的 HTTP 狀態碼
      })

      if (res.data?.error) {
        throw res.data?.error
      }
      return res
    } catch (e) {
      console.error('request error:', e)
      if (e.message?.includes('Failed to fetch')) {
        _errorHandler && _errorHandler({ code: 'ERR_998' })
      } else if (e.data) {
        _errorHandler && _errorHandler(e.data.error)
        throw e.data.error
      }
      throw e
    }
  }

  return {
    provide: {
      request: {
        send: request,
        // setApiUrl,
        setErrorHandler,
      },
    },
  }
})
